import Raven from 'raven-js';
import { fetchJsonBlob } from '../api/jsonBlobApi';
import { USER_SETTING_KEY } from '../trial/prompts/ContextualTrialPromptContainer';
export const contextualPromptPromise = () => {
  return fetchJsonBlob(USER_SETTING_KEY).then(response => {
    return response;
  }).catch(error => {
    const requestError = error;
    if (!('status' in requestError) || requestError.status !== 404) {
      console.error('Error fetching json blob for contextual prompt', requestError);
      Raven.captureException(requestError);
    }
    return {};
  });
};